import { ReactElement } from 'react';
import { TextInput } from '@components/common';
import { keyDownEvent } from '@helper/utils';

type BuilderDetailsProps = {
	// Formik is structurally typed, accept any object with the needed members
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	formik: any;
	isVisible: boolean;
	disabled?: boolean;
};

export const BuilderDetailsSection = ({ formik, isVisible, disabled }: BuilderDetailsProps): ReactElement | null => {
	if (!isVisible) return null;

	const { values, errors, touched } = formik;
	return (
		<>
			<li key="builder-name" className="form-control d-col d-col-2">
				<TextInput
					id="builder_name"
					name="builder_name"
					label="Builder Name"
					type="text"
					onBlur={formik.handleBlur}
					value={(values.builder_name as string) ?? ''}
					setFieldValue={formik.setFieldValue}
					error={touched.builder_name && errors.builder_name ? (errors.builder_name as string) : null}
					required
					disabled={disabled}
				/>
			</li>
			<li key="builder-contact-number" className="form-control d-col d-col-2">
				<TextInput
					id="builder_phone_number"
					name="builder_phone_number"
					label="Builder Contact Number"
					type="text"
					onBlur={formik.handleBlur}
					value={(values.builder_phone_number as string) ?? ''}
					setFieldValue={formik.setFieldValue}
					onKeyDown={keyDownEvent}
					maxLength={10}
					error={
						touched.builder_phone_number && errors.builder_phone_number ? (errors.builder_phone_number as string) : null
					}
					required
					disabled={disabled}
				/>
			</li>
			<li key="builder-office-address" className="form-control d-col d-col-2">
				<TextInput
					id="builder_office_address"
					name="builder_office_address"
					label="Builder Office Address"
					type="text"
					onBlur={formik.handleBlur}
					value={(values.builder_office_address as string) ?? ''}
					setFieldValue={formik.setFieldValue}
					error={
						touched.builder_office_address && errors.builder_office_address
							? (errors.builder_office_address as string)
							: null
					}
					disabled={disabled}
				/>
			</li>
		</>
	);
};
